import React, { useMemo } from "react";
import { Alert, Button, Empty, Table } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import useDetailTableHeight from "./useDetailTableHeight";

const money = (value) => value == null ? "—" : `$${Number(value) < 0 ? "-" : ""}${Math.abs(Number(value)).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const transactionMoney = (value) => value == null || Number(value) === 0 ? "" : money(value);
const balance = (value) => <strong className={Number(value) > 0 ? "notice-ledger-debit" : "notice-ledger-credit"}>{money(value)}</strong>;
const descriptions = { IN: "Invoice", P: "Payment", S: "Sys", D: "D" };

export default function LedgerDetails({ ledger, error, onRetry, amount }) {
  const [tableHost, tableHeight] = useDetailTableHeight(ledger, error);
  // Preserve each transaction's original running balance; only reverse its display position.
  const newestFirst = useMemo(() => [...(ledger?.items || [])].reverse(), [ledger]);
  return <section className="notice-detail-panel notice-ledger-panel" aria-label="Ledger Card">
    <header className="notice-panel-header">
      <div className="notice-panel-heading">
        <div className="notice-panel-title"><h3>Ledger Card</h3><span>Last 12 months</span></div>
        <p>Latest transactions first</p>
      </div>
      <div className="notice-detail-balance">
        <span className="notice-detail-label">Ledger Card End Balance</span><strong>{amount}</strong>
      </div>
    </header>
    {error ? <Alert showIcon type="error" message={error}
      action={<Button size="small" icon={<ReloadOutlined />} aria-label="Retry ledger details" onClick={onRetry}>Retry</Button>} /> : <div className="notice-detail-table-host" ref={tableHost}>
      <Table className="notice-detail-table notice-ledger-table" size="small" pagination={false}
        loading={!ledger} dataSource={newestFirst} rowKey="cntlNo"
        scroll={{ x: 1250, y: tableHeight }}
        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No transactions in the last 12 months" /> }}
        columns={[
          { title: "Date", dataIndex: "date1", width: 100 },
          { title: "Desc", dataIndex: "txCode", width: 90, render: (code) => descriptions[code] || code },
          { title: "Batch", dataIndex: "batch", width: 85 },
          { title: "Check No", dataIndex: "checkNo", width: 85 },
          { title: "Invoice", dataIndex: "appyto", width: 85 },
          { title: "GL", dataIndex: "glAcct", width: 65 },
          { title: "Service", dataIndex: "serviceCode", width: 75 },
          { title: "Remark", dataIndex: "remark", width: 235 },
          { title: "Charge", dataIndex: "charge", align: "right", width: 105, render: transactionMoney },
          { title: "Payment", dataIndex: "payment", align: "right", width: 105, render: transactionMoney },
          { title: "Balance", dataIndex: "balance", align: "right", width: 120, fixed: "right", render: balance },
        ]}
        summary={() => ledger && <Table.Summary fixed="top"><Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={8}><strong>Ending balance · {ledger.endDate}</strong></Table.Summary.Cell>
          <Table.Summary.Cell index={8} align="right">{money(ledger.totalCharge)}</Table.Summary.Cell>
          <Table.Summary.Cell index={9} align="right">{money(ledger.totalPayment)}</Table.Summary.Cell>
          <Table.Summary.Cell index={10} align="right">{balance(ledger.endBalance)}</Table.Summary.Cell>
        </Table.Summary.Row></Table.Summary>} />
    </div>}
  </section>;
}
